module.exports = __webpack_public_path__ + "img/20200507_135845.8ec442b0.jpg";